import * as React from "react";

function NotFound() {
  return <h1>Pagina no existe</h1>;
}

export default NotFound;
